// Wire types for the per-tenant per-user Dashboards admin surface.
//
// A dashboard is a saved layout of up to 16 camera tiles arranged in a
// 12×8 CSS grid. Tiles carry their grid-area span + the camera id they
// pin. Persistence is per-(tenant, alias) — no sharing model.

export const DASHBOARD_MAX_TILES = 16;
export const DASHBOARD_GRID_COLS = 12;
export const DASHBOARD_GRID_ROWS = 8;

export interface DashboardTile {
  /** Stable per-tile id within the dashboard (uuidv7-ish). */
  tile_id: string;
  /** Camera bound to this tile. Wire format matches /api/cameras. */
  doorbot_id: string;
  /** Top-left grid cell (1-indexed CSS grid lines). */
  col_start: number;
  row_start: number;
  /** Span (column / row count). The tile covers col_start..col_start+col_span-1. */
  col_span: number;
  row_span: number;
}

export interface Dashboard {
  dashboard_id: string;
  tenant_id: string;
  /** Owning user alias. Dashboards are private to this alias. */
  alias: string;
  display_name: string;
  /** Up to 16 tiles per DASHBOARD_MAX_TILES. */
  tiles: DashboardTile[];
  version: number;
  created_at: string;
  created_by: string;
  updated_at?: string;
  updated_by?: string;
}

export interface CreateDashboardRequest {
  display_name: string;
  tiles?: DashboardTile[];
}

export interface UpdateDashboardRequest {
  display_name?: string;
  tiles?: DashboardTile[];
}
